module.exports = "/_next/static/images/img__select-vuz-children_desktop-024ace5c8b96022a20bc2f5371b4cb0e.png";